import { SmartSearchPicker } from "./SmartSearchPicker";

// Generic searchable/autocomplete select over a canonical list (same UX as HorsePicker).
// items: [{ value, label }]. Mobile-safe: inline popover on desktop, bottom sheet on phones.
export function SearchSelect({ items = [], value, onChange, testId, placeholder = "Cerca…", disabled }) {
  const sel = items.find((i) => i.value === value);
  return (
    <SmartSearchPicker testId={testId} placeholder={placeholder} disabled={disabled}
      displayLabel={sel ? sel.label : ""} mobileTitle="Seleziona">
      {(q, { close, optionProps }) => {
        const nq = (q || "").trim().toLowerCase();
        const filtered = nq ? items.filter((i) => (i.label || "").toLowerCase().includes(nq)) : items;
        if (filtered.length === 0) return <p className="px-3 py-2 text-sm text-[#8C6D4F]">Nessun risultato</p>;
        return filtered.slice(0, 60).map((i) => (
          <button key={i.value} type="button" data-testid={testId ? `${testId}-opt-${i.value}` : undefined}
            {...optionProps(() => { onChange(i.value, i); close(); })}
            className="w-full text-left px-3 py-2 text-sm hover:bg-[#F0EAE1] text-[#1B3B2B]">{i.label}</button>
        ));
      }}
    </SmartSearchPicker>
  );
}
